/**
 * API Configuration
 * Reads environment variables and provides centralized API configuration
 */

const BASE_URL = process.env.REACT_APP_BASE_URL || window.location.origin;

// By default the app talks to the backend that serves it (same origin, /api/v2).
// Set REACT_APP_API_BASE_URL only when the frontend is hosted apart from the backend.
const DEFAULT_API_BASE_URL = `${window.location.origin}/api/v2`;
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL).replace(/\/$/, '');
const SUBSCRIPTION_API_BASE_URL = (
  process.env.REACT_APP_SUBSCRIPTION_API_BASE_URL || API_BASE_URL
).replace(/\/$/, '');

const ORDER_CREATE_ENDPOINT = '/orders/create';
const PAYMENT_CONFIRM_ENDPOINT = '/confirm-payment';
const SUBSCRIPTION_CREATE_ENDPOINT = `${SUBSCRIPTION_API_BASE_URL}/subscriptions/create`;
const SUBSCRIPTION_PAYMENT_CONFIRM_ENDPOINT = `${SUBSCRIPTION_API_BASE_URL}/confirm-payment`;
const SUBSCRIPTION_GIFTS_ENDPOINT = `${SUBSCRIPTION_API_BASE_URL}/gifts`;
const SUBSCRIPTION_GIFT_CHOOSE_ENDPOINT = `${SUBSCRIPTION_API_BASE_URL}/gifts/choose`;
const PAYMENT_CALLBACK_URL = `${BASE_URL}?step=payment-callback`;
const SUBSCRIPTION_CALLBACK_URL = PAYMENT_CALLBACK_URL;

export const API_ENDPOINTS = {
  ORDER_CREATE: `${API_BASE_URL}${ORDER_CREATE_ENDPOINT}`,
  PAYMENT_CONFIRM: `${API_BASE_URL}${PAYMENT_CONFIRM_ENDPOINT}`,
  SUBSCRIPTION_CREATE: SUBSCRIPTION_CREATE_ENDPOINT,
  SUBSCRIPTION_PAYMENT_CONFIRM: SUBSCRIPTION_PAYMENT_CONFIRM_ENDPOINT,
  SUBSCRIPTION_GIFTS: SUBSCRIPTION_GIFTS_ENDPOINT,
  SUBSCRIPTION_GIFT_CHOOSE: SUBSCRIPTION_GIFT_CHOOSE_ENDPOINT,
};

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  SUBSCRIPTION_BASE_URL: SUBSCRIPTION_API_BASE_URL,
  CALLBACK_URL: PAYMENT_CALLBACK_URL,
  ENDPOINTS: {
    CREATE_ORDER: ORDER_CREATE_ENDPOINT,
    CONFIRM_PAYMENT: PAYMENT_CONFIRM_ENDPOINT,
  },
  SUBSCRIPTION_CALLBACK_URL,
  TIMEOUT: 30000, // 30 seconds
};

export default API_CONFIG;
